import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const styles = tv({
    slots: {
        root: "iris:font-(family-name:--comp-type-font-pagination)",
        list: `
      iris:inline-flex iris:w-full iris:list-none iris:items-center iris:justify-center
      iris:gap-(--comp-space-gap-pagination-items)
      iris:text-(length:--comp-type-size-pagination)
    `,
        iconContainer: `
      iris:flex
      iris:h-full
      iris:w-full
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-pagination-button)
      iris:group-hover:bg-(--comp-color-background-pagination-button-hover)
      iris:group-active:bg-(--comp-color-background-pagination-button-pressed)
    `,
        icon: "iris:size-(--comp-size-icon-pagination-button)",
        iconLeft: "iris:pr-(--base-space-px-2)",
        iconRight: "iris:pl-(--base-space-px-2)",
        button: `
      iris:group
      iris:flex iris:size-(--comp-size-box-pagination-button) iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-pagination-button)
      iris:border-(length:--comp-size-border-pagination-button)
      iris:bg-(--comp-color-background-pagination-button-rest)
      iris:tracking-(--comp-type-tracking-pagination)
      iris:duration-(--comp-motion-duration-pagination)
      iris:ease-(--comp-motion-easing-pagination)
    `,
        items: `
      iris:flex iris:size-(--comp-size-box-pagination-item) iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-pagination-item)
      iris:px-(--comp-space-padding-pagination-horizontal)
      iris:py-(--comp-space-padding-pagination-vertical)
      iris:font-(--comp-type-weight-pagination)
      iris:tracking-(--comp-type-tracking-pagination)
      iris:duration-(--comp-motion-duration-pagination)
      iris:ease-(--comp-motion-easing-pagination)
    `,
        ring: `
      iris:outline-none
    `,
        truncation: `
      iris:flex iris:items-center iris:justify-center
      iris:p-(--comp-space-padding-pagination-truncation-all)
      iris:tracking-(--comp-type-tracking-pagination)
    `,
        itemInteract: "iris:cursor-pointer",
        selected: `
      iris:cursor-default
      iris:font-(--comp-type-weight-pagination-selected)!
    `,
    },
    variants: {
        inverse: {
            false: {
                ring: focusStyles.default,
                iconContainer: `
                iris:group-hover:bg-(--comp-color-background-pagination-button-hover)
                iris:group-active:bg-(--comp-color-background-pagination-button-pressed)
                `,
                itemInteract: `
          iris:bg-(--comp-color-background-pagination-item-rest)
          iris:text-(--comp-color-content-pagination-item)
          iris:hover:bg-(--comp-color-background-pagination-item-hover)
          iris:active:bg-(--comp-color-background-pagination-item-pressed)
        `,
                button: `
          iris:border-(--comp-color-border-pagination-button)
          iris:bg-(--comp-color-background-pagination-button-rest)
          iris:text-(--comp-color-content-pagination-button)
        `,
                selected: `
          iris:bg-(--comp-color-background-pagination-item-selected)
          iris:text-(--comp-color-content-pagination-item-selected)
        `,
                truncation: "iris:text-(--comp-color-content-pagination-item)",
            },
            true: {
                ring: focusStyles.inverse,
                button: `
          iris:border-(--comp-color-border-pagination-button-inverse)
          iris:bg-(--comp-color-background-pagination-button-inverse-rest)
          iris:text-(--comp-color-content-pagination-button-inverse)
        `,
                iconContainer: `
                iris:group-hover:bg-(--comp-color-background-pagination-button-inverse-hover)
                iris:group-active:bg-(--comp-color-background-pagination-button-inverse-pressed)
                `,
                itemInteract: `
          iris:bg-(--comp-color-background-pagination-item-inverse-rest)
          iris:text-(--comp-color-content-pagination-item-inverse)
          iris:hover:bg-(--comp-color-background-pagination-item-inverse-hover)
          iris:active:bg-(--comp-color-background-pagination-item-inverse-pressed)
        `,
                selected: `
          iris:text-(--comp-color-content-pagination-item-inverse-selected);
          iris:bg-(--comp-color-background-pagination-item-inverse-selected)
        `,
                truncation: "iris:text-(--comp-color-content-pagination-item-inverse)",
            },
        },
    },
});

export { styles as default };
